import articlesIndex from "./articles/articlesIndex";
import carouselIndex from "./carousel_slides/carouselIndex";
import {
  logoName,
  logoImg,
  logoAzulForm,
  isotipoAzul,
  notFoundImg,
} from "./logos/logosIndex";
import { services, companyPros, teamHome } from "./home_imgs/homeIndex";
import partnersIndex from "./partners/partnersIndex";
import teamIndex from "./team_photos/teamIndex";
import testimonialsIndex from "./testimonial_images/testimonialsIndex";
import { clinicalWork, modelingWork } from "./how_we_work/workIndex";

const plans = [
  {
    id: 1,
    title: "Plan1Title",
    price: 60,
    discount: 0,
    trialTime: 30,
    modality: "monthly",
    slogan: "Plan1Slogan",
    benefits: ["Plan1Benefit1"],
  },
  {
    id: 2,
    title: "Plan2Title",
    price: 600,
    discount: 380,
    trialTime: 30,
    modality: "yearly",
    slogan: "Plan2Slogan",
    benefits: ["Plan2Benefit1"],
  },
];



export {
  articlesIndex,
  carouselIndex,
  logoName,
  logoImg,
  logoAzulForm,
  isotipoAzul,
  services,
  companyPros,
  partnersIndex,
  testimonialsIndex,
  teamIndex,
  plans,
  teamHome,
  notFoundImg,
  clinicalWork,
  modelingWork,

};
